import React from 'react';

const ResolutionNotSupport = () => {
  return (
    <div className="mobile-warning">
      <div className="top-bar">
        <img
          src={require('./../../images/idea-logo-2026.svg')}
          alt=""
          className="logo"
        />

      </div>

      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <div className="text-center">
              <h1>Database</h1>

              <h3 className="hlp-mb-10">
                Constitution-Building Processes in Conflict-Affected States
              </h3>
              <p className="hlp-mb-20 fz14 bold tc-dark">
                Our tool is not available for your resolution
              </p>

              <img src={require('./../../images/devices.png')} alt="" />

              <p className="fz14 bold tc-dark">
                To use our tool optimally, please switch to desktop or tablet
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResolutionNotSupport;
